// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__CtUvN","table":"styles_table__nrAtZ","infoLink":"styles_infoLink__ahBSt"};